import { toast } from "sonner";
import { parseApiError } from "@freightsimple/api-runtime/errors";
import { ErrorToastContent } from "./ErrorToastContent";

export async function showApiError(
  error: unknown,
  context?: string,
): Promise<void> {
  const info = await parseApiError(error);
  const title = context
    ? `${context} (${info.source})`
    : `Error (${info.source})`;
  toast.error(title, {
    description: <ErrorToastContent {...info} />,
    duration: 30_000,
    ...(info.details && { style: { width: "min(480px, 45vw)" } }),
  });
}
